/**
 * deriveHeaders — the ONE way to get a dataset's header list from its data.
 *
 * Returns the union of property keys across ALL features, in first-seen
 * order. Every site that used to do `Object.keys(features[0].properties)`
 * had the same hole: a first feature with sparse/empty properties yields a
 * partial or empty header list, and that list then gets persisted on the
 * dataset doc and drives the color/size/label pickers. Deriving from one
 * feature is never correct for real field data (CSV exports routinely
 * leave the first row blank in some columns).
 *
 * Cheap even for large files: it's one Object.keys per feature, and
 * duplicates are absorbed by the Set.
 */
export function deriveHeaders (geojson) {
  if (!geojson || !Array.isArray(geojson.features)) return []
  const keys = new Set()
  for (const f of geojson.features) {
    if (f && f.properties && typeof f.properties === 'object') {
      for (const k of Object.keys(f.properties)) keys.add(k)
    }
  }
  return Array.from(keys)
}

/** Union of two header lists, preserving `a`'s order then `b`'s additions. */
export function mergeHeaders (a, b) {
  const out = []
  const seen = new Set()
  for (const list of [a || [], b || []]) {
    for (const h of list) {
      if (h != null && !seen.has(h)) { seen.add(h); out.push(h) }
    }
  }
  return out
}
